/** 是否是外部网址
 *
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * 去掉前后空格
 *
 * @param {*} str
 * @returns
 */
export function trimVal(str) {
  if (!str) {
    return str;
  }

  const reg = /^\s+|\s+$/g;
  return str.replace(reg, '');
}


/**
 * 校验 手机
 *
 * @export
 * @param {*} val
 * @returns
 */
export function isMobile(val) {
  const reg = /^0?(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
  return reg.test(val);
}


/**
 * 校验 手机
 * 规则: 以1为开头，总共11位数
 *
 * @export
 * @param {*} val
 * @returns
 */
export function isMobileSimple(val) {
  const reg = /^1/;
  return reg.test(val) && val.toString().length === 11;
}


/**
 * 校验 固定电话
 * 规则: 必须带区号
 *
 * @export
 * @param {*} val
 * @returns
 */
export function isTelephone(val) {
  const reg = /^0[1-9][0-9]{1,2}-[2-8][0-9]{6,7}$/;
  return reg.test(val);
}

/**
 * 校验 邮箱
 *
 * @export
 * @param {*} val
 * @returns
 */
export function isEmail(val) {
  /* eslint-disable no-useless-escape */
  const reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
  return reg.test(val);
}

/**
 * 校验 QQ
 *
 * @export
 * @param {*} val
 * @returns
 */
export function isQQ(val) {
  const reg = /^[1-9][0-9]{4,9}$/gim;
  return reg.test(val);
}

/**
 * 充值金额
 * @param {*} value
 * 数值 仅限小数点后两位
 */
export function amountValidator(value) {
  return /^(\d+)(.\d{0,2})?$/.test(value);
}

/**
 * 身份证校验
 * @param {*} id
 */
export function isIdCard(id) {
  const regId = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  return regId.test(id);
}

export default {
  requiredInput: { required: true, message: '不能为空', trigger: 'blur' },
};
